module.exports = __webpack_public_path__ + "static/img/button-right-icon.52a74d52.svg";